import { z } from 'zod'

export const MENTORING_OFFER_EMAIL_DELIVERY = {
  SENT: 'sent',
  FAILED: 'failed'
} as const

export const UpsertMentoringOfferOutputDTOZ = z.object({
  offerId: z.uuid(),
  /** The `/mentoring/<id>` path staff copies and hands to the buyer. */
  offerPath: z.string(),
  /** Absolute URL shown to staff and stored on the CRM event the campaign mails. */
  offerUrl: z.url(),
  /**
   * `sent` only when a campaign took the CRM event and now owns the message -
   * never a promise that the buyer received it. `failed` covers every case
   * where nothing is sending: no CRM event, no campaign listening, or an engine
   * failure. The durable link above stays on the screen either way, so a failed
   * one can be handed over by hand.
   */
  emailDelivery: z.enum(Object.values(MENTORING_OFFER_EMAIL_DELIVERY))
})

export type UpsertMentoringOfferOutputDTO = z.infer<typeof UpsertMentoringOfferOutputDTOZ>
